import styled from 'styled-components';
import Department from './Department';

const Departments = styled.div`
  width : 100%
`

const DepartmentsContainer = ({departments}) => {
  return (
    <Departments>
      { departments.length > 0 &&
          departments.map((department, index) => (
            <Department
              name={department.name}
              members={department.members}
              key={index}
            />
          ))
      }
    </Departments>
  )
}

export default DepartmentsContainer;
